/**
 * CSS media query for detecting reduced motion preference.
 * Use with emotion/styled-components/tss-react style objects.
 *
 * @example
 * const styles = {
 *   transition: 'transform 0.3s ease',
 *   [REDUCED_MOTION_MEDIA_QUERY]: {
 *     transition: 'none',
 *   },
 * };
 */
export const REDUCED_MOTION_MEDIA_QUERY =
  '@media (prefers-reduced-motion: reduce)';

/**
 * Default styles to apply when reduced motion is preferred.
 * Removes transitions and animations.
 */
export const reducedMotionStyles = {
  transition: 'none',
  animation: 'none',
} as const;

/**
 * Helper to create style objects with reduced motion support.
 * Wraps normal styles with a media query override for reduced motion.
 *
 * @example
 * const buttonStyles = withReducedMotion(
 *   { transition: 'transform 0.3s ease' },
 *   { transition: 'none' }
 * );
 */
export const withReducedMotion = <T extends Record<string, unknown>>(
  normalStyles: T,
  reducedStyles: Record<string, unknown> = reducedMotionStyles
) => ({
  ...normalStyles,
  [REDUCED_MOTION_MEDIA_QUERY]: reducedStyles,
});
